import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';

// 출발지·도착지 공통 입력 — 의뢰자 정보와 같은 항목(상호 · 부서명 / 담당자명 · 연락처). 퀵·화물·이사 세 서비스가 같이 쓴다.
// side: 'start' | 'end'  → 스토어 키 startCompany·startDept·startNm·startTel / endCompany·endDept·endNm·endTel
export const SIDE_FIELDS = [
  { key: 'Company', placeholder: '상호', autoComplete: 'organization', col: 'half' },
  { key: 'Dept', placeholder: '부서명', autoComplete: 'organization-title', col: 'half' },
  { key: 'Nm', placeholder: '담당자명', autoComplete: 'name', col: 'name' },
  { key: 'Tel', placeholder: '연락처', autoComplete: 'tel', inputMode: 'tel', col: 'phone' },
];

export const sideKey = (side, key) => `${side}${key}`;

// 한 쪽(출발지/도착지)에 들어갈 값 묶음 — 불러오기 버튼이 쓴다
export const sideValues = (side, src) => ({
  [sideKey(side, 'AddrDtl')]: src.addrDtl,
  [sideKey(side, 'Company')]: src.company,
  [sideKey(side, 'Dept')]: src.dept,
  [sideKey(side, 'Nm')]: src.name,
  [sideKey(side, 'Tel')]: src.tel,
});

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    flexWrap: 'nowrap',
  },
  // 데스크톱 — 370px 폭 안에 두 칸(상호 180 · 부서명 180 / 담당자 130 · 연락처 230)
  half: { '& .MuiInputBase-root': { width: '180px !important', marginRight: 10 } },
  halfLast: { '& .MuiInputBase-root': { width: '180px !important', marginRight: 0 } },
  name: { '& .MuiInputBase-root': { width: '130px !important', marginRight: 10 } },
  phone: { '& .MuiInputBase-root': { width: '230px !important', marginRight: 0 } },
  // 모바일 — 그리드 비율로
  dense: {
    '& $cell': { paddingRight: 5 },
    '& $cell:last-child': { paddingRight: 0 },
    '& .MuiInputBase-root': { width: '100%', padding: '0 12px !important' },
  },
  cell: {},
}));

function SideFields({ side, values, onChange, dense = false }) {
  const cs = useStyles();
  const field = (f, className) => (
    <TextField
      key={f.key}
      className={clsx('formArea textBox', className)}
      fullWidth={dense}
      variant="outlined"
      name={sideKey(side, f.key)}
      placeholder={f.placeholder}
      value={values[sideKey(side, f.key)] || ''}
      onChange={onChange}
      inputProps={{ autoComplete: f.autoComplete, inputMode: f.inputMode }}
    />
  );
  const [company, dept, name, tel] = SIDE_FIELDS;

  if (dense) {
    return (
      <div className={cs.dense}>
        <Grid container className={cs.row}>
          <Grid item xs={6} className={cs.cell}>{field(company)}</Grid>
          <Grid item xs={6} className={cs.cell}>{field(dept)}</Grid>
        </Grid>
        <Grid container className={cs.row}>
          <Grid item xs={5} className={cs.cell}>{field(name)}</Grid>
          <Grid item xs={7} className={cs.cell}>{field(tel)}</Grid>
        </Grid>
      </div>
    );
  }
  return (
    <React.Fragment>
      <Grid container className={cs.row} direction="row" alignItems="center">
        {field(company, cs.half)}
        {field(dept, cs.halfLast)}
      </Grid>
      <Grid container className={cs.row} direction="row" alignItems="center">
        {field(name, cs.name)}
        {field(tel, cs.phone)}
      </Grid>
    </React.Fragment>
  );
}

export default SideFields;
